module.exports = __webpack_public_path__ + "img/neck.79e3f33f.svg";